import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { t } from "i18next";
import './Carousel.css'
import { useTranslation } from "react-i18next"; 
import { hero, playCircle, rightUp } from "../../../assets/index";
 
  const Carousel = () => {

  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const slides = [
    { img: hero, text: "Biznesinizə Yön Verəcək Texnoloji İnnovasiyalar və Komfortlu Ofis Sahələri", content: "Biznes mərkəzimizdə müasir ofis sahələri və qlobal şəbəkə imkanları ilə işinizi bir addım öndə tutun." },
    // { img: hero, text: "TANURA ilə Hər Gün Təravətli Dəri", content: "Həkim-kosmetoloq və kosmetoloqlar üçün nəzərdə tutulmuş məhsullar" },
    // { img: hero, text: "TANURA ilə Hər Gün Təravətli Dəri", content: "Həkim-kosmetoloq və kosmetoloqlar üçün nəzərdə tutulmuş məhsullar" },
  ];

  useEffect(() => {
    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 500);

    const buttonTimer = setTimeout(() => {
      setShowButton(true);
    }, 1500);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(buttonTimer);
    };
  }, [activeIndex]);

  return (
    <div className="md:max-w-container mx-auto rounded-lg h-[450px] md:h-[750px]">
      {/* Header is placed outside the Swiper for it to stay on top */}

      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        onSlideChange={(swiper) => {
          setShowText(false);
          setShowButton(false);
          setActiveIndex(swiper.activeIndex);
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      > 
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative">
              <img src={slide.img} alt={`Slide ${index + 1}`} className="w-full h-[343px] md:h-[598px] object-cover md:rounded-[16px] mt-32" />
              {activeIndex === index && (
                <div className="absolute inset-0 flex flex-col px-[16px] md:px-0 justify-center items-center lg:items-start text-white lg:px-[80px] transition-opacity duration-1000">
                  <div className="md:w-[903px] relative md:text-center lg:text-left md:mb-48">
                    <h2 className={`text-white text-[18px] font-barlow md:text-[32px] font-semibold mb-4 md:mb-6 md:mt-[250px] mt-[32px] lg:mb-6 transition-all duration-1000 transform ${showText ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}`}>
                      <p className="font-barlow font-bold text-[24px] md:text-[40px]" >Biznesinizə Yön Verəcək Texnoloji İnnovasiyalar və Komfortlu <span className="text-[#AD131A] font-barlow">Ofis Sahələri</span></p>
                    </h2>
                    <h2 className={` text-white text-[16px] md:text-[20px] font-medium mb-5 lg:mb-5 md:w-[70%] transition-all duration-1000 transform ${showText ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}`}>
                      {t(slide.content)}
                    </h2>

                    <div className="flex justify-between">
                    <a href='/about'> <button className=' text-[white] hover:bg-[#898989] hover:border-[#898989] rounded-[8px] border-2 border-white w-[148px] h-[40px] flex items-center justify-center'>
  Daha çox
</button></a>
                    </div> 
              
                  </div> 
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
